import * as authApi from "../api/signupService";

export async function signup(request) {
    const resultPage = await authApi
        .signup(request)
        return resultPage;
}